// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('.product-card').forEach(card => {
//     const radios = card.querySelectorAll('.material-radio');
//     const display = card.querySelector('.selected-material-name');
//     const variantInputs = card.querySelectorAll('input[name="id"]'); // 👈 ALL inputs

//     if (!radios.length || !variantInputs.length || !display) return;

//     function updateVariantInputs(variantId) {
//       variantInputs.forEach(input => {
//         input.value = variantId;
//         input.dispatchEvent(new Event('change', { bubbles: true }));
//       });
//     }

//     function syncUI() {
//       radios.forEach(radio => {
//         radio
//           .closest('.material-option')
//           .classList.toggle('is-active', radio.checked);
//       });
//     }

//     // ✅ auto-select first enabled radio
//     const firstEnabled = Array.from(radios).find(r => !r.disabled);
//     if (firstEnabled) {
//       firstEnabled.checked = true;
//       updateVariantInputs(firstEnabled.dataset.variantId);
//       display.textContent = firstEnabled.dataset.materialName;
//       syncUI();
//     }

//     radios.forEach(radio => {
//       radio.addEventListener('change', () => {
//         updateVariantInputs(radio.dataset.variantId);
//         display.textContent = radio.dataset.materialName;
//         syncUI();
//       });
//     });
//   });
// });



/*
 * The card material-swatch handler that used to live here has been superseded by
 * assets/card-swatches.js, which also swaps the card image and the variant price and
 * survives AJAX re-renders. It was removed rather than left in place because it
 * force-checked the first available radio on load, overriding both the state Liquid
 * renders and the shared controller.
 */




document.addEventListener('DOMContentLoaded', () => {
  // Keeps every option group's ".swatch-value" (the selected value printed under the
  // swatch circles) in sync with that group's own checked input.
  function updateSwatchValue() {
    document
      .querySelectorAll('.product-form__input, .swatch, .variant-input')
      .forEach((group) => {
        const swatchValueEl = group.querySelector('.swatch-value');
        if (!swatchValueEl) return;

        const checkedInput = group.querySelector('input[type="radio"]:checked');
        if (!checkedInput) return;

        const value = checkedInput.value;

        // prevent useless rewrites
        if (swatchValueEl.textContent.trim() !== value) {
          swatchValueEl.textContent = value;
        }
      });
  }

  // user interaction
  document.addEventListener('change', (e) => {
    if (e.target.matches('input[type="radio"]')) {
      updateSwatchValue();
    }
  });

  // 🔥 Shrine Pro AJAX watcher
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        updateSwatchValue();
        break;
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  updateSwatchValue();
});




/*
  Sticky ATC — current variant option name + value  (v3)

  Reads the live variant picker and renders one chip per option:
      Metal: 18K Gold Plated    Color: Maroon

  Target:  <div class="variant-sticky-option-name"
                data-option-names="{{ product.options | join: '|' | escape }}"></div>

  Console: stickyVariant.diagnose()
*/
(function () {
  'use strict';

  const VERSION = '3.0.0';
  const DEBUG = true;

  // If the container div is missing, build it inside the sticky bar anyway.
  const AUTO_CREATE_TARGET = true;

  const TARGET_SELECTOR = '.variant-sticky-option-name';
  const STICKY_SELECTOR = 'sticky-atc';
  const SKIPPED_TYPES = ['hidden'];

  // Main picker first, sticky bar's own picker as backup.
  const PICKER_SELECTORS = [
    'variant-selects',
    'secondary-variant-select',
    'secondary-variant-select-separate',
  ];

  const tag = '%c[sticky-variant]';
  const css = 'color:#7c3aed;font-weight:bold';
  const log = (...a) => DEBUG && console.log(tag, css, ...a);
  const warn = (...a) => DEBUG && console.warn(tag, css, ...a);

  log('loaded v' + VERSION);

  const isVisible = (el) =>
    !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);

  /* ------------------------------------------------------------------
     TARGET
  ------------------------------------------------------------------ */
  function ensureTarget() {
    let targets = Array.from(document.querySelectorAll(TARGET_SELECTOR));
    if (targets.length || !AUTO_CREATE_TARGET) return targets;

    const sticky = document.querySelector(STICKY_SELECTOR);
    if (!sticky) return [];

    // Clean up any hardcoded empty chips left in the snippet.
    const strays = sticky.querySelectorAll('.variant-sticky-option');
    let anchor = null;
    strays.forEach(function (s, i) {
      if (i === 0) anchor = s.nextSibling;
      s.remove();
    });
    if (strays.length) log('removed ' + strays.length + ' hardcoded empty chip(s)');

    const div = document.createElement('div');
    div.className = 'variant-sticky-option-name';

    const content =
      sticky.querySelector('.sticky-atc__left__content') ||
      sticky.querySelector('.sticky-atc__left') ||
      sticky;

    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(div, anchor);
    else content.appendChild(div);

    warn('target div was missing — created one. Add it to your liquid instead:\n<div class="variant-sticky-option-name" data-option-names="{{ product.options | join: \'|\' | escape }}"></div>');

    return [div];
  }

  /* ------------------------------------------------------------------
     PICKER
  ------------------------------------------------------------------ */
  function findPicker() {
    const all = [];
    PICKER_SELECTORS.forEach(function (sel, rank) {
      document.querySelectorAll(sel).forEach(function (el) {
        all.push({ el: el, rank: rank });
      });
    });
    if (!all.length) return null;

    const scored = all.map(function (c) {
      let score = 20 - c.rank * 5; // prefer the main picker
      if (isVisible(c.el)) score += 10;
      score += c.el.querySelectorAll('input[type="radio"]:checked').length * 3;
      score += c.el.querySelectorAll('select.select__select').length * 3;
      score += c.el.querySelectorAll('.product-form__input').length;
      if (c.el.closest(TARGET_SELECTOR)) score = -100;
      // combined picker (one select of full variant titles) can't give per-option names
      if (c.el.querySelector('.sticky-atc__variant-select')) score -= 15;
      return { el: c.el, score: score };
    });

    scored.sort((a, b) => b.score - a.score);
    return scored[0].score > 0 ? scored[0].el : null;
  }

  /* ------------------------------------------------------------------
     READ
  ------------------------------------------------------------------ */
  function getOptionName(wrapper, input, index) {
    if (wrapper && wrapper.dataset.optionName) return wrapper.dataset.optionName.trim();

    if (input && input.tagName === 'SELECT') {
      const m = (input.name || '').match(/options\[(.+?)\]/);
      if (m) return m[1];
    }

    const label = wrapper && wrapper.querySelector('.form__label');
    if (label) {
      const clone = label.cloneNode(true);
      clone
        .querySelectorAll('.swatch-value, .visually-hidden, .sizing-chart, a, button')
        .forEach((n) => n.remove());
      const text = clone.textContent.replace(/\s+/g, ' ').replace(/[:：]\s*$/, '').trim();
      if (text) return text;
    }

    // names published by liquid on the target div
    const names = getDeclaredNames();
    if (names[index]) return names[index];

    if (input && input.name) return input.name.replace(/\[.*?\]/g, '').trim();
    return '';
  }

  function getDeclaredNames() {
    const t = document.querySelector(TARGET_SELECTOR);
    const raw = t && t.dataset.optionNames;
    return raw ? raw.split('|').map((s) => s.trim()) : [];
  }

  function readFromPicker(picker) {
    const out = [];
    if (!picker) return out;

    const wrappers = Array.from(picker.querySelectorAll('.product-form__input'));
    wrappers.forEach(function (wrapper, i) {
      const typeEl = wrapper.querySelector('.product-form__input__type');
      const type = typeEl ? typeEl.dataset.type || '' : '';
      if (SKIPPED_TYPES.indexOf(type) !== -1) return;

      let input = wrapper.querySelector('select.select__select');
      let value = '';

      if (input) {
        if (input.classList.contains('sticky-atc__variant-select')) return; // combined picker
        value = input.value;
      } else {
        input = wrapper.querySelector('input[type="radio"]:checked');
        if (!input) return;
        value = input.value;
      }

      value = (value || '').trim();
      if (!value) return;

      out.push({ name: getOptionName(wrapper, input, out.length), value: value });
    });

    return out;
  }

  // Last resort: variant title ("Gold / 16") zipped with declared option names.
  function readFromVariantTitle() {
    const el = document.querySelector('.sticky-atc__variant');
    if (!el) return [];
    const parts = el.textContent.trim().split(' / ').map((s) => s.trim()).filter(Boolean);
    if (!parts.length || parts[0] === 'Default Title') return [];

    const names = getDeclaredNames();
    return parts.map((value, i) => ({ name: names[i] || '', value: value }));
  }

  function readOptions() {
    const picker = findPicker();
    let options = readFromPicker(picker);
    if (!options.length) {
      options = readFromVariantTitle();
      if (options.length) log('used variant-title fallback');
    }
    return options;
  }

  /* ------------------------------------------------------------------
     RENDER
  ------------------------------------------------------------------ */
  const signature = (opts) => opts.map((o) => o.name + '\u0000' + o.value).join('\u0001');

  function buildChip(opt) {
    const chip = document.createElement('span');
    chip.className = 'variant-sticky-option';

    if (opt.name) {
      const n = document.createElement('span');
      n.className = 'variant-sticky-option__name';
      n.textContent = opt.name + ':';
      chip.appendChild(n);
      chip.appendChild(document.createTextNode(' '));
    }

    const v = document.createElement('span');
    v.className = 'variant-sticky-option__value';
    v.textContent = opt.value;
    chip.appendChild(v);

    return chip;
  }

  function render(reason) {
    const targets = ensureTarget();
    if (!targets.length) return false;

    const options = readOptions();
    const sig = signature(options);

    targets.forEach(function (target) {
      if (target.dataset.signature === sig) return;

      target.textContent = '';
      options.forEach((opt) => target.appendChild(buildChip(opt)));

      target.dataset.signature = sig;
      target.dataset.optionCount = String(options.length);
      target.classList.toggle('is-empty', options.length === 0);

      log(
        'rendered ' + options.length + ' option(s) [' + (reason || 'update') + ']',
        options.map((o) => o.name + ': ' + o.value)
      );
    });

    return options.length > 0;
  }

  let frame = null;
  function scheduleRender(reason) {
    if (frame) return;
    frame = requestAnimationFrame(function () {
      frame = null;
      render(reason);
    });
  }

  /* ------------------------------------------------------------------
     DIAGNOSE
  ------------------------------------------------------------------ */
  function diagnose() {
    console.group('%c[sticky-variant] diagnose v' + VERSION, css);

    const sticky = document.querySelector(STICKY_SELECTOR);
    const targets = document.querySelectorAll(TARGET_SELECTOR);
    const picker = findPicker();

    console.log('<sticky-atc> present:', !!sticky, sticky);
    console.log('targets (' + TARGET_SELECTOR + '):', targets.length, targets);
    console.log('declared option names:', getDeclaredNames());
    console.log('picker chosen:', picker);

    if (!sticky) console.error('No <sticky-atc>. The sticky ATC block is not enabled on this template.');
    if (!targets.length) console.error('No target div — add it to the sticky snippet (see notes).');

    if (picker) {
      console.log('.product-form__input:', picker.querySelectorAll('.product-form__input').length);
      console.log('checked radios:', picker.querySelectorAll('input[type="radio"]:checked').length);
      console.log('selects:', picker.querySelectorAll('select.select__select').length);
      console.table(readFromPicker(picker));
    } else {
      console.error('No picker found. Product may have only a default variant.');
    }

    console.log('variant-title fallback would give:', readFromVariantTitle());
    console.groupEnd();

    return { sticky: sticky, targets: targets, picker: picker, options: readOptions() };
  }

  /* ------------------------------------------------------------------
     BOOT
  ------------------------------------------------------------------ */
  function init() {
    render('init');

    document.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"], select')) scheduleRender('change');
    }, true);

    document.addEventListener('click', function (e) {
      if (e.target.closest('.product-form__input, .quantity-break, .color-swatch, label')) {
        scheduleRender('click');
      }
    }, true);

    new MutationObserver(() => scheduleRender('mutation')).observe(document.body, {
      childList: true,
      subtree: true,
    });

    document.addEventListener('shopify:section:load', () => scheduleRender('section:load'));
    document.addEventListener('variant:change', () => scheduleRender('variant:change'));

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, () => scheduleRender('pubsub'));
    }

    let tries = 0;
    const poll = setInterval(function () {
      tries++;
      if (render('poll ' + tries) || tries >= 20) {
        clearInterval(poll);
        if (tries >= 20) warn('nothing rendered after 10s — run stickyVariant.diagnose()');
      }
    }, 500);
  }

  window.stickyVariant = {
    version: VERSION,
    render: render,
    diagnose: diagnose,
    findPicker: findPicker,
    readOptions: readOptions,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();